/**
 * Extend tc_vars with additional analytics data
 * @param {Object} additionalData - Key-value pairs to add to tc_vars
 */
export const extendTcVars = (additionalData) => {
    window.tc_vars = {
        ...window.tc_vars,
        ...additionalData,
    };
};
